// extracted by mini-css-extract-plugin
module.exports = {"openingHours":"OpeningHours_openingHours__4_nyq","srOnly":"OpeningHours_srOnly__dS3jY"};